import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { HttpService } from './http.service'
import { UserInfoService } from './user-info.service'
import { HttpClient } from '@angular/common/http';

@Injectable()
export class AuthService {

  _jwt = new JwtHelperService();
  private redirectUrl: string;
  public message: string;

  constructor(private _http: HttpClient, private httpService: HttpService,
              private userService: UserInfoService) {
  }


  /**
   * check for expiration and if token is still existing or not
   * @return {boolean}
   */
  isAuthenticated(): boolean {
    return localStorage.getItem('token') != null && !this._jwt.isTokenExpired();
  }

  setRedirectUrl(url: string): void {
    this.redirectUrl = url;
  }

  getRedirectUrl(): string {
    return this.redirectUrl;
  }

  /**
   * this is used to clear anything that needs to be removed
   */
  clear(): void {
    localStorage.clear();
  }

  /**
   * this returns the token for the user
   * @param email
   * @param password
   */
  // authenticate(email: string, password: string): Observable<string> {
  //   return this._apiHandler.callService("/user/login", RequestMethod.Post, {email: email, password: password})
  //     .map(res => <string>res.text())
  //     .do((token: string) => {
  //       localStorage.setItem('token', token);
  //       this._userService.set(this._jwt.decodeToken());
  //     });
  // }

  /**
   * this is used to alert our caller if we should go get token for next request or
   * to be carried out request
   *
   * @param threshold_seconds  is like a threshold to check if we should or not check for token
   * default we use 2min before the token expires
   *
   * @return {boolean}
   */
  async shouldIGetToken(threshold_seconds: number = 120): Promise<boolean> {
    const tokenExpirationDate = await this._jwt.getTokenExpirationDate();
  
    // Handle case where the expiration date is not available or invalid
    if (!(tokenExpirationDate instanceof Date)) {
      return true; // If there's no valid expiration date, assume token should be refreshed
    }
  
    const expTime = tokenExpirationDate.valueOf();  // Get expiration time in milliseconds
    const currentTime = new Date().valueOf();       // Get current time in milliseconds
    const thresholdTime = threshold_seconds * 1000; // Convert threshold seconds to milliseconds
  
    // Check if current time is greater than the expiration time minus the threshold
    return currentTime > (expTime - thresholdTime);
  }

  /**
   * this is used to retrieve a newer token since the current one is going to expire soon
   *
   */
  retrieveToken() {
    console.log('&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&&77')
    this.userService.getUserIdFromToken().then((data:any)=>{
      console.log(data, "hhhhh-h-h-hh-")
      this.httpService.retrieveToken(data.id).subscribe(token=>{
        console.log('neeeeewww----token', token)
        //this.clear();
        localStorage.setItem('token', token.token);
      })
    })
    .catch(err=>{
      console.log('problem in retrive token')
      //window.location.href = '/';
    })
  
  }

}
